import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _ from 'lodash';
import store from '@vue/store';
import EntryTable from '@c/mt/entry-table'; // import VueMarkdown from 'vue-markdown'

import SkeletonLoader from '@c/loader/skeleton-loader';
export default {
  components: {
    EntryTable: EntryTable,
    SkeletonLoader: SkeletonLoader
  },
  props: {
    contentType: {
      type: String,
      default: 'entry'
    },
    level: {
      default: 3
    },
    limit: {
      default: 5
    },
    endpoint: null,
    lines: function lines() {
      if (this.contentType == 'entry') {
        return 10;
      } else {
        return 4;
      }
    }
  },
  data: function data() {
    return {
      ready: false,
      list: [],
      title: null,
      href: null,
      excerpt: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getData();

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", null);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }))();
  },
  computed: {
    h: function h() {
      return store.getters['app/h'];
    },
    entries: function entries() {
      try {
        return _.take(this.list, this.limit);
      } catch (error) {
        return [];
      }
    }
  },
  methods: {
    getData: function getData() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var res, _res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(_this2.contentType == 'entry')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return store.dispatch('entries/LIST', _this2.endpoint);

              case 4:
                res = _context2.sent;
                _this2.list = res.items;
                _this2.title = res.blogName;
                _this2.href = res.blogURL;
                _this2.ready = true;
                _context2.next = 18;
                break;

              case 11:
                _context2.next = 13;
                return store.dispatch('webpages/PAGE', _this2.endpoint);

              case 13:
                _res = _context2.sent;
                _this2.title = _res.title;
                _this2.href = "/".concat(_this2.endpoint);
                _this2.excerpt = _res.excerpt;
                _this2.ready = true;

              case 18:
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", null);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 20]]);
      }))();
    }
  }
};